//
// Module for the Participant Communication's Contact Logs view
//
rs.module("content/fund/account/seminars/edit",

    [
        "common/visibility"
    ],

    function (visibility) {

        // Initialize the module
        function initialize(jsSelectors, cssClasses, codeValues, backendUrls, aiEnabled) {

            // Unpack Js Selectors
            var form = $.js(jsSelectors.form);
            var titleInput = form.js(jsSelectors.titleInput);
            var description = form.js(jsSelectors.description);
            var startDateInput = form.js(jsSelectors.startDateInput);
            var startTimeInput = form.js(jsSelectors.startTimeInput);
            var endDateInput = form.js(jsSelectors.endDateInput);
            var endTimeInput = form.js(jsSelectors.endTimeInput);
            var registrationCutoffInput = form.js(jsSelectors.registrationCutoffInput);
            var audienceTypeSelect = form.js(jsSelectors.audienceTypeSelect);
            var seminarTypeSelect = form.js(jsSelectors.audienceTypeSelect);
            var locationSelect = form.js(jsSelectors.locationSelect);            
            var address = form.js(jsSelectors.address);
            var virtualUrlRow = form.js(jsSelectors.virtualUrlRow);
            var virtualUrl = form.js(jsSelectors.virtualUrl);
            var virtualUrlLink = form.js(jsSelectors.virtualUrlLink);
            var guestAllowed = form.js(jsSelectors.guestAllowed);
            var maxAttendees = form.js(jsSelectors.maxAttendees);
            var includesEstimate = form.js(jsSelectors.includesEstimate);
            var displayOnline = form.js(jsSelectors.displayOnline);
            var registeredDetailContainer = form.js(jsSelectors.registeredDetailContainer, { required: false });
            var registeredDetailPanel = form.js(jsSelectors.registeredDetailPanel, { required: false });
            var attendedDetailContainer = form.js(jsSelectors.attendedDetailContainer, { required: false });
            var attendedDetailPanel = form.js(jsSelectors.attendedDetailPanel, { required: false });
            var enhanceButton = form.js(jsSelectors.enhanceButton, { required: false });

            // show/hide attendee detail on hover
            registeredDetailContainer.hoverIntent({
                handlerOver: function () {
                    registeredDetailPanel.toggleClass(cssClasses.visible, true);
                },
                handlerOut: function () {
                    registeredDetailPanel.toggleClass(cssClasses.visible, false);
                },
                hoverOutDelay: 400
            });
            attendedDetailContainer.hoverIntent({
                handlerOver: function () {
                    attendedDetailPanel.toggleClass(cssClasses.visible, true);
                },
                handlerOut: function () {
                    attendedDetailPanel.toggleClass(cssClasses.visible, false);
                },
                hoverOutDelay: 400
            });


            startDateInput.change(function () {
                if (!startDateInput.val()) {
                    startTimeInput.val(null);
                }
                else {
                    endDateInput.val(startDateInput.val());
                }
            });

            startTimeInput.on("change", function () {
                endDateInput.val(startDateInput.val());
                var startTimeArray = startTimeInput.val().split(":");
                var endTimeString = (parseInt(startTimeArray[0]) + 1) + ":" + startTimeArray[1];

                //format needs to have the leading zero to set the end time correctly
                if (endTimeString.length == 4) {
                    endTimeString = "0" + endTimeString;
                }
                endTimeInput.val(endTimeString);
            });

            endDateInput.change(function () {
                if (!endDateInput.val()) {
                    endTimeInput.val(null);
                }
            });

            audienceTypeSelect.on("change", function () {
                var isEmployerAudience = audienceTypeSelect.val() == codeValues.employer;
                if (isEmployerAudience) {
                    guestAllowed.setChecked(false);
                    includesEstimate.setChecked(false);
                    displayOnline.setChecked(false);
                }
                guestAllowed.prop("disabled", isEmployerAudience);
                includesEstimate.prop("disabled", isEmployerAudience);
                displayOnline.prop("disabled", isEmployerAudience);
            });
            
            locationSelect.on("change", function () {
                if (locationSelect.val() == 0 && locationSelect.val() != "") {
                    visibility.show(virtualUrlRow);
                    visibility.hide(address);
                    showUrlIfValid();
                }
                else {
                    visibility.hide(virtualUrlRow);
                    visibility.show(address);
                    visibility.hide(virtualUrlLink);
                }

                $.getJSON(backendUrls.getLocation,
                    { locationKey: locationSelect.val() }
                )
                .done(function (data) {
                    address[0].innerHTML = "";
                    if (data.address1) {
                        address[0].innerHTML += data.address1;
                    }
                    if (data.address2) {
                        address[0].innerHTML += "<br/>" + data.address2;
                    }
                    if (data.city) {
                        address[0].innerHTML += "<br/>" + data.city;
                    }
                    if (data.country == codeValues.usaName && data.state) {
                        address[0].innerHTML += ", " + data.state;
                    }
                    if (data.zipCode) {
                        address[0].innerHTML += " " + data.zipCode
                    }
                    if (data.phone) {
                        address[0].innerHTML += "<br/>" + data.phone
                    }
                });
            });

            virtualUrl.on("input", showUrlIfValid);
            showUrlIfValid();
            // set visibility of virtualUrlLink if virtualUrl.val() is a valid url
            function showUrlIfValid() {
                try {
                    var link = new URL(virtualUrl.val());
                    virtualUrlLink[0].innerHTML = "<a class='input-group-text form-control-sm' href='" + link.href + "' target='_blank'>Join</a>";
                    if (!virtualUrl.is(":disabled")) {
                        visibility.show(virtualUrlLink);
                    }
                }
                catch {
                    virtualUrlLink[0].innerHTML = null;
                    visibility.hide(virtualUrlLink);
                }
            }

            if (aiEnabled) {

                description.on('keyup', _updateAiButtonText);

                _updateAiButtonText();

                // Handle clicking
                enhanceButton.click(function () {
                    enhanceButton.togglePulse();

                    $.post(backendUrls.generateDescription, {
                        title: titleInput.val(),
                        description: description.val(),
                        startDate: startDateInput.val(),
                        startTime: startTimeInput.val(),
                        endDate: endDateInput.val(),
                        endTime: endTimeInput.val(),
                        registrationCutoff: registrationCutoffInput.val(),
                        audience: audienceTypeSelect.val(),
                        seminarType: seminarTypeSelect.val(),
                        location: locationSelect.find(':selected').text(),
                        address: address[0].innerText,
                        isVirtual: virtualUrl.val().length > 0,
                        guestAllowed: guestAllowed.is(":checked"),
                        maxAttendees: maxAttendees.val()
                    })
                    .done(function (result) {
                        description.val(result.description);
                    })
                    .always(function () {
                        enhanceButton.togglePulse(false);
                        _updateAiButtonText();
                    });
                });
            }

            // Set the AI button text based on whether there is already a description
            function _updateAiButtonText() {
                if ($(description).val().length > 0) {
                    enhanceButton.text("Refine");
                }
                else {
                    enhanceButton.text("Draft");
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);